import React from 'react';
import { SolutionPage } from '../../components/solutions/SolutionPage';
import { SolutionDepthSection } from '../../components/solutions/SolutionDepthSection';
import { RelatedSolutions } from '../../components/solutions/RelatedSolutions';
export function LeadershipPage() {
  return <SolutionPage id="leadership" data-id="element-2891" data-mp="1gcwhg60o5xcj">
      <SolutionDepthSection id="leadership" data-id="element-2892" data-mp="1gbv6s2nkfcvc" />
      <RelatedSolutions title="Leadership inside other programs" body="The Leadership capability is shared, so the same exercises and coaching run within these solutions." ids={['government', 'education', 'talent']} data-id="element-2893" data-mp="1gezg1efw0ysv" />
    </SolutionPage>;
}